/* eslint-disable standard/object-curly-even-spacing */

const Constant = {
  install (Vue) {
    Vue.prototype.$constant = Constant
  },
  contractStatus: [{code: 0, text: '使用中'}, {code: 1, text: '未开启'}, {code: 2, text: '已过期'}],
  yn: [{ code: 'y', text: '是' }, { code: 'n', text: '否' }],
  yesNoNum: [{ code: 1, text: '是' }, { code: 0, text: '否' }],
  loginBy: [{ code: 2, text: '邮箱' }, { code: 1, text: '手机号' }],
  tchTags: [
    { code: '不活跃', text: '不活跃' },
    { code: '活跃', text: '活跃' },
  ],
  serviceType: [{ code: 0, text: '否' }, { code: 1, text: '销售专属' }, { code: 2, text: '学导专属' }],
  enabledStatus: [{ code: 1, text: '启用' }, { code: 0, text: '禁用' }],
  userListStatus: [{ code: 1, text: '正常' }, { code: 0, text: '禁用' }],
  userLeaveStatus: [{ code: 1, text: '正常' }, { code: -1, text: '已取消' }],
  adminRuleType: [{ code: 1, text: 'URL' }, { code: 2, text: '菜单' }],
  sex: [{ code: 1, text: '男' }, { code: 2, text: '女' }],
  grade: [{ code: '学龄前', text: '学龄前' }, { code: '幼儿园', text: '幼儿园' },
    { code: '一年级', text: '一年级' }, { code: '二年级', text: '二年级' },
    { code: '三年级', text: '三年级' }, { code: '四年级', text: '四年级' },
    { code: '五年级', text: '五年级' }, { code: '六年级', text: '六年级' },
    { code: '七年级', text: '七年级' }, { code: '八年级', text: '八年级' },
    { code: '九年级', text: '九年级' }, { code: '高一', text: '高一' },
    { code: '高二', text: '高二' }, { code: '高三', text: '高三' }],
  userLessonStatus: [{ code: 0, text: '未测网' }, { code: 1, text: '己测网' }, { code: 2, text: '己试听' }],
  userTrackStatus: [{ code: '0', text: '未处理' }, { code: '1', text: '已处理' }],
  bookCourseChangeStatus: [{ code: 0, text: '未审核' }, { code: 1, text: '通过' }, { code: 2, text: '拒绝' }, { code: 3, text: '复审' }],
  courseType: [
    { code: 1, text: '外教课' },
    { code: 2, text: '中教课' },
    { code: 3, text: '直播课' },
    { code: 4, text: '外教辅修课'},
    { code: 5, text: '外教补课'},
    { code: 6, text: '中教补课'},
    { code: 7, text: '试听课'},
    { code: 8, text: '陪练课'}
  ],
  newCourseType: [
    { code: 1, text: '外教课' },
    { code: 2, text: '中教课' },
    { code: 3, text: '直播课' },
    { code: 4, text: '外教辅修课'},
    { code: 7, text: '试听课'},
    { code: 8, text: '陪练课'}
  ],
  givingType_fq: [
    { code: 1, text: '朋友圈活动' },
    { code: 2, text: '邀请好友' },
    { code: 3, text: '其他' },
    {code: 4, text: '平台问题(classin)'},
    {code: 5, text: '教材问题'},
    // {code: 6, text: '老师问题'}
  ],
  givingType: [
    { code: 1, text: '朋友圈赠课' },
    { code: 2, text: '邀请好友' },
    { code: 3, text: '特殊补贴课时' },
    { code: 4, text: '平台原因(classin)' },
    { code: 5, text: '教材原因' },
    // { code: 6, text: '老师原因' },
    { code: 7, text: '技术(bug)原因' },
    { code: 8, text: '学导原因导致返课' },
    { code: 9, text: '购课赠送课时' },
    { code: 10, text: '退款' },
  ],
  applyDepartment: [
    { code: 4, text: '学导部' },
    { code: 10, text: '销售部' }
  ],
  addSubType: [{ code: 1, text: '加课时' }, { code: 2, text: '减课时' }, { code: 3, text: '加请假次数' }, {code: 4, text: '减请假次数'}, { code: 5, text: '加补课数' }, {code: 6, text: '减补课数'}],
  teacherType: [{ code: 1, text: '共用' }, { code: 2, text: '常规' }, { code: 3, text: '测评' }],
  teacherStatus: [{ code: -1, text: '禁用' }, { code: 0, text: '未激活' }, { code: 1, text: '激活' }, { code: 2, text: '被拒绝' }, { code: 3, text: '离职' }],
  hrList: [
    { code: 'Murphy', text: 'Murphy' },
    { code: 'Louis', text: 'Louis' },
    { code: 'Coco', text: 'Coco' },
    { code: 'Amanda', text: 'Amanda' }
  ],
  isStudyAdviser: [
    { code: 1, text: '已分配' },
    { code: 0, text: '未分配' }
  ],

  teacherCategory: [{ code: 2, text: '正式老师' }, { code: 1, text: '试用期老师' }, { code: 3, text: '工作人员' }, { code: 4, text: '培训中老师' }, { code: 5, text: '面试中老师' }, { code: 6, text: '中介老师' }],

  tchChangeStatusType: [{ code: 1, text: '状态' }, { code: 2, text: '类型' }, { code: 3, text: '职务' }, { code: 4, text: '绑定外教运营' }, { code: 5, text: '绑定学顾' }],
  tchLeaveStatus: [{ code: 1, text: '正常' }, { code: -1, text: '已取消' }],
  tchSignLogStatus: [{ code: 1, text: '签到' }, { code: 2, text: '未签到' }],
  appraise: [{ code: 1, text: '听力' }, { code: 2, text: '口语' }, { code: 3, text: '读' }, { code: 4, text: '读写' }],
  questionType: [{ code: 1, text: '录音题' }, { code: 2, text: '选择题' }, { code: 3, text: '填空题' }],
  questionAnswer: [{ code: '1', text: '选项1' }, { code: '2', text: '选项2' }, { code: '3', text: '选项3' }, { code: '4', text: '选项4' }],
  activityType: [
    { code: 'SHARE_POSTER', text: '分享海报' },
    { code: 'GROUP_ACTIVITY', text: '拼团活动'},
    { code: 'BOOST_ACTIVITY', text: '助力活动'},
    { code: 'LOTTERY_ACTIVITY', text: '抽奖活动'},
    { code: 'LARGE_POSTER', text: '大型活动'}
  ],
  sharePosterType: [
    { code: 'ORDINARY_POSTER', text: '普通海报' },
    { code: 'CUSTOMIZE_POSTER', text: '自定义海报'}
  ],
  giveType: [{ code: 1, text: '课时赠送' }, {code: 2, text: '物品赠送'}],
  studentStatus: [{ code: 1, text: '体验名单' }, {code: 2, text: '体验学生'}, {code: 3, text: '付费学生'}],
  studentServerBy: [{ code: 1, text: '等待确认归属' }, { code: 2, text: '销售独立服务' }, { code: 3, text: '学导服务'}],
  distributionReason: [{ code: 1, text: '新生分配' }, { code: 2, text: '服务原因更换班主任'}, { code: 3, text: '离职交接'}, { code: 4, text: '投诉属实更换班主任'}, { code: 5, text: '无效投诉更换班主任 '}],
  studentStatusAudit: [{ code: 1, text: '停课'}, { code: 2, text: '主修课结课'}, { code: 3, text: '中教课结课'}, { code: 4, text: '陪练课结课'}, { code: 5, text: '常规学生'}, { code: 6, text: '退费学生'}, { code: 7, text: '待开班学生'}, { code: 8, text: '结课学生'}, { code: 9, text: '待分配'}],
  bookLessonOpenedLsnType: [{ code: 0, text: '测网课' }, { code: 1, text: '试听课' }, { code: 2, text: '常规课' }],
  bookLessonOpenedCheckStatus: [{ code: 0, text: '未审核' }, { code: 1, text: '通过' }, { code: 2, text: '未通过' }],
  classType: [{ code: 1, text: 'classIn' }, { code: 2, text: 'hellokid' }],
  tchType: [{code: 0, text: '未分配'}, { code: 1, text: '外教' }, { code: 2, text: '中教' }, { code: 3, text: '陪练'}],
  lessonType: [{code: 0, text: '未分配'}, { code: 1, text: '外教课' }, { code: 2, text: '中教课' }, {code: 3, text: '辅修课'}, {code: 4, text: '陪练课'}],
  itemType: [{code: 1, text: '学生画像'}, {code: 2, text: '试听课预约失败'}, {code: 3, text: '试听课缺席原因'}, {code: 4, text: '试听课课后反馈'}],
  handlerType: [{code: '1', text: '已处理'}, {code: 0, text: '未处理'}],
  tchOpenedTimeType: [{code: 0, text: '无开课'}, { code: 1, text: '有开课' }],
  userTraceType: [
    {code: 0, text: '新注册学生'},
    {code: 1, text: '分配记录'},
    {code: 2, text: '试听课记录'},
    {code: 3, text: '成交记录'},
    {code: 4, text: '交接记录'},
    {code: 5, text: '绑定记录'},
    {code: 6, text: '上课跟进记录'},
    {code: 7, text: '转介绍跟进记录'},
    {code: 99, text: '其他'},
  ],
  recordsSource: [
    {code: 1, text: '手动分配'},
    {code: 2, text: '公共资源'},
    {code: 3, text: '自动分配'},
    {code: 4, text: '扫码推荐关联'},
  ],
  personMessageRouter: [
    {code: 1, text: '注册消息', url: '/user/userTrackList'},
    {code: 11, text: '分配消息', url: '/user/userTrackList'},
    {code: 21, text: '试听课消息', url: '/user/editStudentInfo'},
    {code: 22, text: '试听课失败消息', url: '/message/trailLessonFailedReason'},
    {code: 23, text: '试听课缺席消息', url: '/message/trailLessonAbsentReason'},
    {code: 24, text: '试听课完结后消息', url: '/message/trailLessonFeedBack'},
    {code: 25, text: '试听课完结后提醒是否成功报名', url: '/user/userTrackList'},
    {code: 31, text: '报名成功', url: '/user/parentCommunicationAdviserRecords'},
    {code: 32, text: '报名失败', url: '/user/addOrderFailRecords'},
    {code: 41, text: '寄送教材', url: '/user/userTrackList'},
    {code: 42, text: '和家长沟通确认', url: '/user/userTrackList'},
    {code: 43, text: '分配学导后提醒和家长沟通', url: '/user/parentCommunicationRecords'},
    {code: 51, text: '绑定消息', url: '/user/userTrackList'},
    {code: 52, text: '解绑消息', url: '/user/userTrackList'},
    {code: 61, text: '上课跟进消息', url: '/user/userTrackList'},
    {code: 62, text: '转移学导记录', url: '/user/userTrackList'},
    {code: 63, text: '完成一个等级课程', url: '/user/userTrackList'},
    {code: 64, text: '完结相应课节数量提醒', url: '/user/userTrackList'},
    {code: 65, text: '超过一个月未联系提醒', url: '/user/userTrackList'},
    {code: 66, text: '开课时间提醒', url: '/user/userTrackList'},
    {code: 67, text: '绑定有效时间失效记录', url: '/user/userTrackList'},
    {code: 68, text: '提示配送教材', url: '/user/addSendMaterialRecords'},
    {code: 99, text: '其他'},
  ],
  lsnSelStatus: [
    { code: 1, text: '已选' },
    { code: 2, text: '上课中' },
    { code: 3, text: '已上课' },
    { code: 4, text: '学生请假' },
    { code: 5, text: '学生旷课' },
    { code: 6, text: '老师请假' },
    { code: 7, text: '老师旷课' },
    { code: 8, text: '老师迟到' },
    { code: 9, text: '学生老师旷课' },
    { code: 10, text: '学生旷课老师迟到' },
    { code: 11, text: '管理员取消' },
    { code: 12, text: '学生取消' },
    { code: 13, text: '老师离职' },
  ],
  complaintReason: [
    { code: 1, text: '上课吃东西' },
    { code: 2, text: '上课打电话' },
    { code: 3, text: '没上课技巧' },
    { code: 4, text: '上课不认真' },
    { code: 5, text: '中途离开' },
    { code: 6, text: '网太差' },
    { code: 7, text: '不纠正孩子发音' }
  ],

  fundPackageState: [{ code: 0, text: '待支付' }, { code: 1, text: '支付成功' }, { code: 2, text: '订单已添加' }, {code: 3, text: '合同关闭'}, {code: 4, text: '部分支付'}, {code: 5, text: '全部支付'}, {code: 6, text: '财务已审核'}, {code: 9, text: '已退费'}],
  fundUserBillType: [{ code: 1, text: '支付宝' }, { code: 2, text: '微信' }],
  payWay: [{code: 1, text: '支付宝'}, {code: 2, text: '微信'}, {code: 9, text: '其他'}],
  payWayNew: [{code: 2, text: '微信'}, {code: 1, text: '支付宝'}, {code: 9, text: '其他'}],
  payWay2: [{code: 1, text: '微信'}, {code: 2, text: '支付宝'}, {code: 9, text: '其他'}],
  isReceive: [{code: 1, text: '是'}, {code: 0, text: '否'}, {code: 2, text: '未审核'}],
  week: [
    { code: 1, text: '周一' },
    { code: 2, text: '周二' },
    { code: 3, text: '周三' },
    { code: 4, text: '周四' },
    { code: 5, text: '周五' },
    { code: 6, text: '周六' },
    { code: 7, text: '周日' }
  ],
  telState: [
    {code: 'dealing', text: '已接'},
    {code: 'notDeal', text: '振铃未接听'},
    {code: 'leak', text: 'ivr放弃'},
    {code: 'queueLeak', text: '排队放弃'},
    {code: 'blackList', text: '黑名单'},
    {code: 'voicemail', text: '留言'},
  ],
  traceStatus: [
    {code: 1, text: '跟进高'},
    {code: 2, text: '跟进中'},
    {code: 3, text: '跟进低'},
    {code: 4, text: '无意向'},
    {code: 5, text: '多次联系不到'},
    {code: 100, text: '注册备注'},
  ],
  traceItem: [
    {code: 1, text: '课后-同意购买'},
    {code: 2, text: '课后-付款成功，持续跟进'},
    {code: 3, text: '课后-讲解产品，学习方案'},
    {code: 4, text: '课后-开场'},
    {code: 5, text: '课前跟进，确认出席'},
    {code: 6, text: '课前跟进，改期'},
    {code: 7, text: '课前约课'},
    {code: 8, text: '价格问题'},
    {code: 9, text: '行业对比'},
    {code: 10, text: '不信任'},
    {code: 11, text: '级别年龄不符'},
    {code: 12, text: '无人接听'},
    {code: 13, text: '挂断'},
    {code: 14, text: '关机/停机'},
    {code: 15, text: '空号'},
  ],
  telCallState: [
    {code: 1, text: '去电'},
    {code: 2, text: '来电'},
  ],
  weekZh: ['周日', '周一', '周二', '周三', '周四', '周五', '周六', '周日'],
  weekSelect: [
    {code: 1, text: '周一'},
    {code: 2, text: '周二'},
    {code: 3, text: '周三'},
    {code: 4, text: '周四'},
    {code: 5, text: '周五'},
    {code: 6, text: '周六'},
    {code: 7, text: '周日'}
  ],
  connectionStatus: [
    { code: 1, text: '未拨打' },
    { code: 2, text: '拨打未接' },
    { code: 3, text: '拨打接通' },
    { code: 4, text: '无效资源' }
  ],
  adviserGroup: [
    { code: 0, text: '全部' },
    { code: 1, text: '销售一部' },
    { code: 2, text: '销售二部' },
    // { code: 3, text: 'Mani组' },
    // { code: 4, text: 'Stan组' },
    // { code: 9, text: '其他' },
  ],
  studentTags: [
    {code: 1, text: '自主下单电脑端'},
    {code: 2, text: '自主下单移动端'},
    {code: 3, text: '转介绍'},
    {code: 4, text: '新春福袋活动'},
    {code: 5, text: '新学期读书计划活动'},
    {code: 6, text: '砍价活动'},
    {code: 7, text: '金币商城活动'},
    {code: 8, text: '年终奖学金活动'},
    {code: 9, text: 'VIP学生'},
    {code: 10, text: '抓气球活动'},
  ],
  channel: [
    { code: 0, text: '其他' },
    { code: 1, text: '在线咨询' },
    { code: 2, text: '来电咨询' }
  ],
  tchLeaveType: [
    { code: 1, text: '常规请假 Standard leave' },
    { code: 2, text: '临时请假 Emergency leave' },
    { code: 4, text: '老师失联NCNS' },
    { code: 5, text: '取消课Cancellation' },
    { code: 6, text: '无责任请假Exempted from leave rate' },
    { code: 7, text: '无责病假Exempted from sick leave rate' },
    { code: 8, text: '无责年假Irresponsible annual leave' },
    { code: 9, text: '离职' },
    { code: 99, text: '其他原因' },
  ],
  tchResignType: [
    { code: 9, text: '离职LeaveOffice' },
    { code: 99, text: '其他原因Other' },
  ],
  resourceStatus: [
    { code: 1, text: '分配资源' },
    { code: 2, text: '公共资源' }
  ],
  intentLevel: [
    { code: 1, text: '高意向' },
    { code: 2, text: '意向一般' },
    { code: 3, text: '待跟进' },
    { code: 4, text: '无效资源' }
  ],
  auditionStatus: [
    { code: 1, text: '未预约' },
    { code: 2, text: '已预约' },
    { code: 3, text: '已试听' }
  ],
  evaluationProgress: [
    { code: 1, text: '未测评' },
    { code: 2, text: '已测评' }
  ],
  stdStatus: [
    { code: -1, text: '全部' },
    { code: 1, text: '新注册学生' },
    { code: 3, text: '已预约' },
    { code: 4, text: '已试听' },
    { code: 5, text: '付款未绑定' },
    { code: 6, text: '已绑定' },
    { code: 7, text: '已开课' },
    { code: 8, text: '已完课' },
    { code: 9, text: '退费' },
    { code: 10, text: '停课' },
    { code: 11, text: '已付款' },
    { code: 12, text: '重新待绑定' },
    { code: 13, text: '绑定未开课' },
    { code: 14, text: '上课中' },
    { code: 15, text: '请假中' },
  ],
  studentCanal: [
    { code: 'gw', text: '官网' },
    { code: 'yd', text: '移动' },
    { code: 'zxzx', text: '在线咨询' },
    { code: 'ldzx', text: '来电咨询' },
    { code: 'tj', text: '二维码推荐' },
    { code: 'gzh', text: '公众号' },
    { code: 'tmk', text: 'TMK' },
    { code: 'qt', text: '其他' },
    { code: 'zj', text: '直接' },
    { code: 'seo', text: 'SEO' },
    { code: 'wb', text: '外部链接' },
    { code: 'bd', text: '百度推广' },
    { code: 'sg', text: '搜狗推广' },
    { code: 'sm', text: '神马推广' },
    { code: '360', text: '360推广' },
    { code: 'qcx', text: '推广合作B' },
    { code: 'jjppc', text: '竞价品牌词' },
    { code: 'pyq', text: '朋友圈' },
    { code: 'pt', text: '拼团' },
    { code: 'ma', text: '拼团小程序' },
    { code: 'hfwj', text: '哈佛外教课' },
    { code: 'seoxzd', text: '一部小站点' },
    { code: 'seoask', text: '一部问答' },
    { code: 'seowx', text: '一部公众号' },
    { code: 'xcx', text: '小程序' },
    { code: 'invite', text: '分享有礼' },
    { code: 'tjyj', text: '推荐有奖' },
    { code: 'monthly_report', text: '月度报告' },
    { code: 'qdhz1', text: '渠道合作一' },
    { code: 'yyw', text: '鹰羽网' },
    { code: '一部趣趣问答', text: '一部趣趣问答' },
    { code: 'stqd1', text: '试听渠道一' },
    { code: 'spoken_word_star', text: '口语之星' },
    { code: 'dljm', text: '代理价加盟' },
    { code: 'qrcode_tj', text: '四月推荐活动(4.13-4.28)'}
  ],
  stdTab: [
    {code: 11, text: '五月推荐活动'},
    {code: 12, text: '618陪练课活动'}
  ],
  leaveType: [
    { code: 1, text: '请单节课' },
    { code: 2, text: '请长假' },
    { code: 3, text: '申请停课' }
  ],
  regTypes: [
    { code: 'gw', text: '官网' },
    { code: 'yd', text: '移动' },
    { code: 'zxzx', text: '在线咨询' },
    { code: 'ldzx', text: '来电咨询' },
    { code: 'tj', text: '二维码推荐' },
    { code: 'gzh', text: '公众号' },
    { code: 'pyq', text: '朋友圈' },
    { code: 'tmk', text: 'TMK' },
    { code: 'qcx', text: '推广合作B' },
    { code: 'jjppc', text: '竞价品牌词' },
    { code: 'xcx', text: '小程序' },
    { code: 'seoxzd', text: '一部小站点' },
    { code: 'seoask', text: '一部问答' },
    { code: 'seowx', text: '一部公众号' },
    { code: 'qt', text: '其他' }
  ],
  accent: [
    { code: 1, text: '英音' },
    { code: 2, text: '美音' },
    { code: 9, text: '其他' }
  ],
  tchChannel: [
    { code: 1, text: '欧美' },
    { code: 2, text: '菲教' },
  ],
  materialVersions: [
    { code: 1, text: '教材1.0' },
    { code: 2, text: 'Wonders' },
    { code: 3, text: '教材3.0' },
    { code: 4, text: '教材4.0' },
    { code: 5, text: '教材5.0' },
    { code: 6, text: '陪练'},
    { code: 10, text: 'Power Up'},
    { code: 9, text: '其他' }
  ],
  invoiceState: [
    { code: 1, text: '未开' },
    { code: 2, text: '部分已开' },
    { code: 3, text: '已开' },
  ],
  invoiceStatus: [
    { code: 1, text: '收据' },
    { code: 2, text: '普通发票' },
    { code: 3, text: '增值税发票' },
    { code: 4, text: '服务发票' },
  ],
  assignList: [
    { code: 0, text: '全部' },
    { code: 1, text: '分配名单' },
    { code: 2, text: '推荐名单' }
  ],
  refundInvoice: [
    { code: 0, text: '未开票' },
    { code: 1, text: '需回收' },
    { code: 2, text: '已经回收' },
  ],
  refundState: [
    { code: -1, text: '删除' },
    { code: 0, text: '待审核' },
    { code: 1, text: '审核通过' },
    { code: 2, text: '财务退款成功' },
    { code: 3, text: '驳回' },
    { code: 9, text: '劝退成功' }
  ],
  refundReasonCategory: [
    { code: 1, text: '外教原因' },
    { code: 2, text: '学导原因' },
    { code: 3, text: '销售原因' },
    { code: 4, text: '技术原因' },
    { code: 5, text: '产品原因' },
    { code: 6, text: '学生客观原因' }
  ],
  mobileRule: /^(\d{3,5}-)?\d{7,12}$/,
  lessonReviewAppraise: [
    {code: 1, text: '听力'},
    {code: 2, text: '口语'},
    {code: 3, text: '读'},
    {code: 4, text: '写作'}
  ],
  lessonReviewQuestionType: [
    {code: 1, text: '录音题'},
    {code: 2, text: '选择题'},
    {code: 3, text: '填空题'},
  ],
  orderChannel: [
    {code: 0, text: '新签'},
    {code: 1, text: '转介绍'},
    // {code: 2, text: '补差'},
    {code: 3, text: '续费'},
    {code: 4, text: '销售续费'},
    {code: 5, text: '结课新签'},
    {code: 6, text: '新签补升'},
    {code: 7, text: '转介绍补升'},
    {code: 8, text: '续费补升'},
    {code: 9, text: '销售续费补升'},
    {code: 10, text: '结课新签补升'},
    {code: 11, text: '订金订单'},
  ],
  orderChannelNew: [
    {code: 0, text: '新签'},
    {code: 1, text: '转介绍'},
    // {code: 2, text: '补差'},
    {code: 3, text: '续费'},
    {code: 4, text: '销售续费'},
    {code: 5, text: '结课新签'},
    {code: 11, text: '订金订单'},
  ],
  orderChannelRenew: [
    {code: 6, text: '新签补升'},
    {code: 7, text: '转介绍补升'},
    {code: 8, text: '续费补升'},
    {code: 9, text: '销售续费补升'},
    {code: 10, text: '结课新签补升'}
  ],
  department: [
    {code: 1, text: '顶级管理组'},
    {code: 2, text: '管理员'},
    {code: 3, text: '产品组'},
    {code: 4, text: '学习导师SC'},
    {code: 6, text: '市场运营'},
    {code: 7, text: '外教运营'},
    {code: 8, text: '教研'},
    {code: 9, text: '已离职'},
    {code: 10, text: '课程顾问CC'},
    {code: 12, text: '临时'},
  ],
  receiveType: [
    {code: 0, text: '有赞'},
    {code: 1, text: '微信'},
    {code: 2, text: '支付宝'},
    {code: 3, text: '转账'},
    {code: 4, text: '库分期'}
  ],
  tchTrackRecordType: [
    {code: 0, text: '加薪记录'},
    {code: 1, text: '请假记录'},
    {code: 2, text: '时间变动'},
    {code: 3, text: '销售评价'},
    {code: 4, text: '学导评价'},
    {code: 5, text: '外管评价'},
    {code: 6, text: '其他'},
    {code: 7, text: '回访'},
    {code: 8, text: '面试记录'},
    {code: 9, text: '培训记录'},
    {code: 10, text: '老师离职'},
    {code: 11, text: '培训淘汰'},
    {code: 12, text: '培训流失'},
    {code: 13, text: '面试笔记'},
  ],
  stuDesc: [
    {code: 1, text: '不自信'},
    {code: 2, text: '坐不住调皮'},
    {code: 3, text: '孩子有基础'},
    {code: 4, text: '孩子基础很好'},
    {code: 5, text: '注意力不集中的'},
    {code: 6, text: '害羞'},
    {code: 7, text: '安静'},
    {code: 8, text: '零基础'},
    {code: 9, text: '基础差'},
    {code: 10, text: '父母是英语老师'},
    {code: 11, text: '去过国外'},
    {code: 12, text: '不喜欢学英语'},
    {code: 13, text: '学生不会用画笔'},
  ],
  askForTch: [
    {code: 114, text: '多拓展'},
    {code: 115, text: '多用道具'},
    {code: 116, text: '给权限'},
    {code: 117, text: '给多点奖杯'},
    {code: 118, text: '做一些口语交流'},
    {code: 119, text: '幽默点'},
    {code: 120, text: '耐心点'},
    {code: 121, text: '活泼点'},
    {code: 122, text: '讲慢点'},
    {code: 123, text: '要纠音'},
    {code: 124, text: '要纠正语法错误'},
    {code: 125, text: '多微笑'},
    {code: 126, text: '多鼓励'},
    {code: 127, text: '多互动'},
    {code: 128, text: '引导/带动孩子'},
    {code: 129, text: '展示下宠物'},
    {code: 130, text: '调动学生的兴趣'},
    {code: 131, text: '不要让学生用画笔'},
    {code: 132, text: '不要打字，说为主'},
    {code: 133, text: '多用肢体语言'},
    {code: 134, text: '引导孩子念句子'},
    {code: 135, text: '不要照本宣科'},
    {code: 136, text: '把课件放大'},
    {code: 137, text: '引导孩子输出'},
  ],
  lessonErrStatus: [
    {code: 0, text: '待处理'},
    {code: 1, text: '已修改'},
    {code: 2, text: '无需处理'}
  ],
  confirm: [
    {code: 0, text: '未确认'},
    {code: 1, text: '确认'},
  ],

  woStatus: [
    {code: 'UNAUDITED', text: '未审核'},
    {code: 'APPROVED', text: '已审核'},
    {code: 'REJECTED', text: '已驳回'},
    {code: 'UN_SUBMITTED', text: '未提交'},
    {code: 'ASSIGNED', text: '分配学导'},
    {code: 'IN_PROGRESS', text: '处理中'},
  ],
  woVersion: [
    {code: 0, text: '旧'},
    {code: 1, text: '新'},
  ],
  paymentType: [
    {code: 'PAYPAL', text: 'PAYPAL'},
    {code: 'PAYONEER_1', text: 'PAYONEER 1%'},
    {code: 'PAYONEER_2', text: 'PAYONEER 2%'},
    {code: 'PAYONEER_6_0', text: 'PAYONEER 6.0'},
    {code: 'DOMESTIC_PAYPAL', text: '国内PAYPAL'},
    {code: 'DOMESTIC_PAYONEER', text: '国内PAYONEER'},
    {code: 'WECHAT', text: '微信'},
    {code: 'ALIPAY', text: '支付宝'},
    {code: 'LOCAL_BANK_ACCOUNT', text: '当地银行卡付款'}
  ],
  userVideoType: [
    {code: 1, text: '萌宝幼儿组'},
    {code: 2, text: '活力少儿组'},
    {code: 3, text: '青春少年组'}
  ],
  auditStatus: [
    {code: 0, text: '待审核'},
    {code: 1, text: '审核通过'},
    {code: 2, text: '审核不通过'},
  ],
  userVideoPhase: [
    {code: 0, text: '未知'},
    {code: 1, text: '初赛'},
    {code: 2, text: '复赛'},
  ],
  userVideoPeriod: [
    {code: 4, text: '第四期'},
    {code: 5, text: '第五期'},
    {code: 6, text: '第六期'},
    {code: 7, text: '第七期'},
  ],
  groupStatus: [
    {code: 0, text: '未付款'},
    {code: 1, text: '拼团中'},
    {code: 2, text: '拼团成功'},
    {code: 3, text: '拼团失败'},
  ],
  courseTypeEnum: [
    {code: 'ONE_TO_ONE', text: '外教一对一'},
  ],
  renewalType: [
    {code: 'RENEWED', text: '已续费'},
    {code: 'NOT_RENEWED', text: '未续费'},
  ],
  tchFeedbackStatus: [{ code: 1, text: '显示' }, { code: 2, text: '隐藏' }],
  reviewClockRecordStatus: [
    {code: 0, text: '未完成'},
    {code: 1, text: '已完成'}
  ],
  reviewClockRecordType: [
    {code: 0, text: '闯关'},
    {code: 1, text: '打卡'}
  ],
  woReason: [
    {code: '开课日期有误', text: '开课日期有误'},
    {code: '备注有误', text: '备注有误'},
  ],
  callType: [
    {code: 'CALL_IN', text: '去电'},
    {code: 'ON_CALL', text: '来电'}
  ],
  callState: [
    {code: 'ANSWERED', text: '已接'},
    {code: 'NOT_ANSWERED', text: '振铃未接听'},
    {code: 'CALLED', text: '被叫'}
  ],
  assignNumEnum: [
    { code: 0, text: '未流转' },
    { code: 1, text: '一次流转' },
    { code: 2, text: '二次流转' }
  ],
  givingTypeEnum: [
    { code: 0, text: '无' },
    { code: 1, text: '朋友圈赠课' },
    { code: 2, text: '邀请好友' },
    { code: 3, text: '特殊补贴课时' },
    { code: 4, text: '平台原因' },
    { code: 5, text: '教材原因' },
    { code: 6, text: '老师原因' },
    { code: 7, text: '技术(bug)原因' },
    { code: 8, text: '学导原因导致返课' },
    { code: 9, text: '购课赠送课时' },
    { code: 10, text: '退款' },
    { code: 11, text: '老师原因' }
  ],
  givingTypeChildEnum: [
    { code: 0, text: '无' },
    { code: 1, text: '课件编辑错' },
    { code: 2, text: '老师离职' },
    { code: 3, text: '老师旷课' },
    { code: 4, text: '老师迟到10分钟以及以上' },
    { code: 5, text: '老师网络原因不能上课' },
    { code: 6, text: '教材不顺延' },
    { code: 7, text: '课件排错' },
    { code: 8, text: '特殊请假' },
    { code: 9, text: '家长态度强硬非要返还课时' },
    { code: 10, text: '转介绍成功购课' },
    { code: 11, text: '邀请好友试听成功' }
  ],
  competitionAreaEnum: [
    { code: 1, text: '杭州赛区' },
    { code: 2, text: '嘉兴赛区' },
    { code: 3, text: '绍兴赛区' },
    { code: 4, text: '金华赛区' },
    { code: 5, text: '温州赛区' },
    { code: 6, text: '台州赛区' },
    { code: 7, text: '台州赛区' },
    { code: 8, text: '舟山赛区' },
    { code: 9, text: '衢州赛区' }
  ],
  ageGroupEnum: [
    { code: 1, text: '6-9岁' },
    { code: 2, text: '10-12岁' },
    { code: 3, text: '13-16岁' }
  ],
  phaseEnum: [
    { code: 0, text: '未知' },
    { code: 1, text: '初赛' },
    { code: 2, text: '复赛' },
    { code: 3, text: '终赛' }
  ],
  schoolEnums: [
    { code: 0, text: '邦德尔英语' }
  ],
  tchComplaintRemark: [
    { text: '上课知识点讲解错误，发音错误', stdNum: 2, tchNum: 6, subSalary: 1},
    { text: '外教不备课', stdNum: 2, tchNum: 6, subSalary: 1},
    { text: '外教上课态度不好', stdNum: 2, tchNum: 6, subSalary: 1},
    { text: '外教上课看手机、回复消息、浏览其他不相关网站', stdNum: 2, tchNum: 6, subSalary: 1},
    { text: '外教上课吃东西、喝酒、抽烟、喝水不算', stdNum: 2, tchNum: 6, subSalary: 1},
    { text: '外教教学环境嘈杂', stdNum: 2, tchNum: 6, subSalary: 1},
    { text: '外教上课言论不当（与我们的政治立场相反）', stdNum: 2, tchNum: 6, subSalary: 1},
    { text: '外教衣着不得体、鼻环、舌钉', stdNum: 2, tchNum: 6, subSalary: 1},
    { text: '外教上课混时间，播放非教材视频超过2分钟', stdNum: 2, tchNum: 6, subSalary: 1},
    { text: '外教迟到', stdNum: 0, tchNum: 0, subSalary: 0},
    { text: '外教早退', stdNum: 0, tchNum: 0, subSalary: 0},
    { text: '外教缺席', stdNum: 0, tchNum: 0, subSalary: 0},
    { text: '外教临时请假', stdNum: 0, tchNum: 0, subSalary: 0},
    { text: '外教离职', stdNum: 0, tchNum: 0, subSalary: 0},
    { text: '网络原因', stdNum: 0, tchNum: 0, subSalary: 0},
  ],
  stdOverRemark: [
    {text: '价格贵'},
    {text: '转线下'},
    {text: '服务不满意'},
    {text: '课程不满意'},
    {text: '老师不满意'},
    {text: '没时间 '},
    {text: '效果不好 '},
    {text: 'app 不满意 '},
    {text: '无配套预复习 '},
    {text: '规划不定 '},
    {text: '退费 '},
  ],
  checkStatus: [
    {code: 0, text: '未确认'},
    {code: 1, text: '已确认'},
    {code: 2, text: '已拒绝'},
  ],
  yesOrNo: [
    {code: false, text: '否'},
    {code: true, text: '是'},
  ],
  channelTypeEnum: [{id: 'A', text: 'A'}, {id: 'B', text: 'B'}, {id: 'C', text: 'C'}, {id: 'N', text: 'N'}, {id: 'P', text: 'P'}, {id: 'R', text: 'R'}, {id: '代理', text: '代理'}, {id: '新渠道', text: '新渠道'}],
  getEnum (data, key) {
    let obj
    data.forEach(e => {
      if (e.code === key) {
        obj = e
        return
      }
    })
    return obj
  }
}
export default Constant



// WEBPACK FOOTER //
// ./src/plugins/Constant.js